import { render, staticRenderFns } from "./PayrollList.vue?vue&type=template&id=3bcd8c83&scoped=true&"
import script from "./PayrollList.vue?vue&type=script&lang=ts&"
export * from "./PayrollList.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollList.vue?vue&type=style&index=0&id=3bcd8c83&prod&scoped=true&lang=css&"
import style1 from "./PayrollList.vue?vue&type=style&index=1&id=3bcd8c83&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd8c83",
  null
  
)

export default component.exports